export const REQUEST_FOR_LIFE_EVENTS_SECTIONS =
  'REQUEST_FOR_LIFE_EVENTS_SECTIONS';
export const GET_LIFE_EVENTS_SECTIONS_SUCCESS =
  'GET_LIFE_EVENTS_SECTIONS_SUCCESS';
export const GET_LIFE_EVENTS_SECTIONS_ERROR = 'GET_LIFE_EVENTS_SECTIONS_ERROR';
